import React from 'react';

import { Button, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { format } from '../../../../date-fns-locale';
import { type ApiKey } from '../../../../types/apiTypes';
import ApiKeysContainer from '../../ApiKeysContainer';

const StyledButton = styled(Button)`
    padding: 0px;
    display: flex;
    justify-content: flex-start;
`;

const StyledTableCell = styled(TableCell)`
    vertical-align: top;
`;

interface RowProps {
    apiKey: ApiKey
}

const KeysListTableRow: React.FC<RowProps> = ({ apiKey }) => {
    const { t } = useTranslation('admin_settings');
    const history = useHistory();
    const { path } = useRouteMatch();
    const { setSelectedKey, setFormActionType } = useContainer(ApiKeysContainer);
    const { name, scopes, expires_at: expiresAt } = apiKey;

    const formattedExpiresAt = expiresAt === null ? t('api-keys.no-expiration') : format(new Date(expiresAt), 'P');

    const renderLocalizedScopes = () => {
        const localizedScopes = scopes.map((scope) => {
            const nestedValueString = scope.replace(':', '-');
            return t(`api-keys.key-scopes-property.${nestedValueString}`);
        });
        return (
            <div>{localizedScopes.join(', ')}</div>
        );
    };

    const handleClick = () => {
        setSelectedKey(apiKey);
        setFormActionType('EDIT');
        history.push(`${path}/edit`);
    };

    return (
        <>
            <TableRow>
                <StyledTableCell>
                    <StyledButton onClick={handleClick}>{name}</StyledButton>
                    {renderLocalizedScopes()}
                </StyledTableCell>
                <StyledTableCell>{formattedExpiresAt}</StyledTableCell>
            </TableRow>
        </>
    );
};

export default KeysListTableRow;
